import { all, fork } from 'redux-saga/effects';

// public
import chatSaga from './chat/saga';

export default function* rootSaga() {
  yield all([
    // public
    fork(chatSaga),
  ]);
}
